"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextPainter = void 0;
var Painter_1 = require("../../Painter");
var round_1 = require("../../../util/round");
var measureNodeCanvasTextCorrection_1 = require("../../../util/text-metrics/measureNodeCanvasTextCorrection");
var toFontProperty_1 = require("../../../util/text-metrics/toFontProperty");
/**
 * Implements drawing-related operations for text.
 */
var TextPainter = /** @class */ (function (_super) {
    __extends(TextPainter, _super);
    function TextPainter(mode) {
        var _this = _super.call(this, "text") || this;
        _this.mode = mode;
        _this.baseWidthOf = function (object) { return object.width; };
        _this.baseHeightOf = function (object) { return object.height; };
        return _this;
    }
    TextPainter.prototype.paintFill = function (store, object) {
        var ctx = store.layers.result.ctx;
        ctx.save();
        ctx.font = toFontProperty_1.toFontProperty(object);
        ctx.textAlign = object.textAlign;
        ctx.fillStyle = object.fillStyle;
        ctx.textBaseline = "middle";
        var xOffset = round_1.round(object, this._xOffsetOf(object));
        ctx.translate(xOffset, round_1.round(object, 0.5 * object.height));
        ctx.fillText(object.content, 0, this._yCorrectionOf(object, store.layers.device));
        ctx.restore();
    };
    TextPainter.prototype._xOffsetOf = function (object) {
        if (object.textAlign == "center") {
            return 0.5 * object.width;
        }
        else if (object.textAlign == "right" || object.textAlign == "end") {
            return object.width;
        }
        else {
            return 0;
        }
    };
    TextPainter.prototype._yCorrectionOf = function (object, device) {
        if (this.mode !== "node" || object.content.trim() === "") {
            return 0;
        }
        return measureNodeCanvasTextCorrection_1.measureNodeCanvasTextCorrection(object, device);
    };
    TextPainter.prototype.paintStroke = function (store, object) {
    };
    TextPainter.prototype.shouldRepaint = function (previousData, newData) {
        var keys = [
            "content", "textAlign", "fillStyle"
        ];
        return _super.prototype.shouldRepaint.call(this, previousData, newData)
            || keys.some(function (key) { return previousData[key] !== newData[key]; })
            || toFontProperty_1.toFontProperty(previousData) !== toFontProperty_1.toFontProperty(newData);
    };
    return TextPainter;
}(Painter_1.Painter));
exports.TextPainter = TextPainter;
//# sourceMappingURL=TextPainter.js.map